// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1fach","notes":"Notes_notes__2g0a-"};